export enum RELATIONSHIP_TYPE {
  Affiliated = "Affiliated",
  Subsidiary = "Subsidiary",
  None = "None",
  Root = "Root"
}
